import { gql } from "@apollo/client";

export const DeleteGridItem = gql`
    mutation DeleteGridItem($id: ID!) {
        deleteGridItem(id: $id) {
            success
            message
        }
    }
`;
